import { Injectable, inject } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_PROJECT_BY_ID,
  SOFTLINE_API_PROJECT_COST_CENTER,
  SOFTLINE_API_PROJECT_LEADER,
  SOFTLINE_API_PROJECT_PARTICIPANT,
} from '../roster.api';
import { Project } from '../types/object';
import { ObjectQuery } from '../types/object-query';

@Injectable({
  providedIn: 'root',
})
export class SoftlineObjectRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  public async getObjectsForCostCenter(
    body: ObjectQuery
  ): Promise<Project[]> {
    return await this.dataAccess.create(
      {
        path: SOFTLINE_API_PROJECT_COST_CENTER,
      },
      body
    );
  }
  public async getObjectsForLeader(body: ObjectQuery): Promise<Project[]> {
    return await this.dataAccess.create(
      {
        path: SOFTLINE_API_PROJECT_LEADER,
      },
      body
    );
  }

  getObjectsForParticipant = async (body: ObjectQuery): Promise<Project[]> => {
    return await this.dataAccess.create(
      {
        path: SOFTLINE_API_PROJECT_PARTICIPANT,
      },
      body
    );
  };

  public async getObject(objectId: string): Promise<Project> {
    return await this.dataAccess.get({
      path: SOFTLINE_API_PROJECT_BY_ID,
      pathParams: { objectId: objectId },
    });
  }
}
